var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:_vm.$style.section},[_c('div',{class:_vm.$style.bounce},_vm._l((2),function(circle){return _c('div',{key:circle,class:_vm.$style.circle})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }